module.exports = __webpack_public_path__ + "static/media/password_illustration.ba0733ea.png";